"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Accordion_1 = require("../Accordion");

var FooterNavigation =
/** @class */
function (_super) {
  __extends(FooterNavigation, _super);

  function FooterNavigation() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      viewport: utils_1.WindowEvents.getViewportSize()
    };

    _this.onResize = function (viewportSize) {
      _this.setState({
        viewport: viewportSize
      });
    };

    return _this;
  }

  FooterNavigation.prototype.componentDidMount = function () {
    utils_1.WindowEvents.addViewportCallback(this.onResize);
  };

  FooterNavigation.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeViewportCallback(this.onResize);
  };

  FooterNavigation.prototype.render = function () {
    return ["lg", "xl"].includes(this.state.viewport) ? React.createElement("ul", {
      className: CSSPrefix_1.lsgPre + "footer-navigation"
    }, this.props.children) : React.createElement(Accordion_1.AccordionGroup.Stateful, {
      className: CSSPrefix_1.lsgPre + "footer-navigation " + CSSPrefix_1.lsgPre + "theme__dark"
    }, this.props.children);
  };

  FooterNavigation.Block = function (_a) {
    var children = _a.children,
        title = _a.title,
        other = __rest(_a, ["children", "title"]);

    var linkList = React.createElement("ul", {
      className: CSSPrefix_1.lsgPre + "footer-navigation-block-list"
    }, React.Children.map(children, function (child) {
      return React.createElement("li", null, child);
    }));
    return ["lg", "xl"].includes(utils_1.WindowEvents.getViewportSize()) ? React.createElement("li", {
      className: CSSPrefix_1.lsgPre + "footer-navigation-block"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "footer-navigation-block-title",
      role: "heading",
      "aria-level": 3
    }, title), linkList) : React.createElement(Accordion_1.Accordion, __assign({}, other, {
      title: title
    }), linkList);
  };

  return FooterNavigation;
}(React.Component);

exports.FooterNavigation = FooterNavigation;
FooterNavigation.Block.displayName = "FooterNavigation.Block";